/** Reads the configured browser socket endpoint without creating a transport. */
export const getSocketUrlEnv = (): string | undefined => {
  const value = import.meta.env.VITE_SOCKET_CONNECTION_URL;
  return typeof value === 'string' && value.length > 0 ? value : undefined;
};

/**
 * Adds the authenticated handshake token to a configured endpoint.
 * @param baseUrl - Socket endpoint.
 * @param token - Current account's handshake token.
 * @returns The encoded URL.
 * @throws When the configured URL is invalid; the connection owner reports it.
 */
export const buildSocketUrl = (baseUrl: string, token: string): string => {
  const url = new URL(baseUrl);
  url.searchParams.set('token', token);
  return url.toString();
};

/**
 * Checks whether the current transport can send a frame.
 * @param socket - Transport to inspect.
 * @returns Whether its ready state is open.
 */
export const isSocketOpen = (socket: WebSocket): boolean =>
  socket.readyState === WebSocket.OPEN;
